import type { LocationWindow } from 'types';
import type { CcmCampaignType } from 'modules/campaigns/components/ccm/types';

export function getCcmCampaignTypeFromQuery(query: LocationWindow['query']): CcmCampaignType {
  const creatorFull: CcmCampaignType = 'creatorfull';
  const cType: undefined | string = query.campaign_type;
  const types: Array<CcmCampaignType> = ['creatorfull', 'creatorless'];

  if (types.includes(cType as any)) {
    return cType as CcmCampaignType;
  }

  return creatorFull;
}
